module.exports = __webpack_public_path__ + "img/gwtw.29725497.png";